module.exports = __webpack_public_path__ + "img/banner_gbr.f8216248.png";